import { type Descendant } from 'slate';

import { Element } from '@@editor/helpers';
import { ELEMENT_TYPES, type ParagraphElement } from '@@editor/helpers/Element';

const createSimpleTextState = (text = '') => [
    Element.create<ParagraphElement>({
        type: ELEMENT_TYPES.PARAGRAPH,
        data: {},
        children: [
            {
                text,
            },
        ],
    }),
];

// Creating a valid state for Slate editor
const makeState = (value?: Descendant[] | string | null | undefined): Element[] => {
    if (Element.isElementList(value)) {
        if (value.length > 0) {
            return value;
        }

        return createSimpleTextState();
    }

    if (typeof value === 'string') {
        return createSimpleTextState(value);
    }

    if (value == null) {
        return createSimpleTextState();
    }

    throw new Error(
        'Could not create a valid state for passed value:\n' + JSON.stringify(value, null, 2),
    );
};

export default makeState;
